import { useEffect } from 'react'
import ReactGA from 'react-ga4'

import { useAnalyticsConsent } from '@analytics/consent'

const GOOGLE_ANALYTICS_ID_PROD = 'G-Q003PPV42B'
const GOOGLE_ANALYTICS_ID_TEST = 'G-CY9T0DVEM7'

const getEnvironment = (): string => {
  return (window as any)?.env?.APP_ENVIRONMENT || 'development'
}

const isProduction = (): boolean => {
  return getEnvironment() === 'prod-bo01'
}

/**
 * Initialises react-ga4 (used for custom events via `useGAEvents`) only after
 * the visitor granted analytics consent via CookieYes. Page views are not sent
 * from here: GTM already owns the Google tag for the same measurement ID.
 */
export const useGoogleAnalytics = (): void => {
  const hasConsent = useAnalyticsConsent()

  useEffect(() => {
    if (!hasConsent || ReactGA.isInitialized) return

    const trackingId = isProduction() ? GOOGLE_ANALYTICS_ID_PROD : GOOGLE_ANALYTICS_ID_TEST
    const isDebugMode = !isProduction()

    ReactGA.initialize([
      {
        trackingId,
        gtagOptions: { debug_mode: isDebugMode, send_page_view: false },
      },
    ])
  }, [hasConsent])
}
